module.exports = __webpack_public_path__ + "static/media/icn_search_gray.b65b0691.svg";